import { render, staticRenderFns } from "./DynamicListwithVersion.vue?vue&type=template&id=42f3b7ac&scoped=true&"
import script from "./DynamicListwithVersion.vue?vue&type=script&lang=js&"
export * from "./DynamicListwithVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f3b7ac",
  null
  
)

export default component.exports